/* Seat detail map for /seats/{CODE}/ pages */
(function () {
    var API_BASE = 'https://pollingreport.uk/api/v1';
    var LEAFLET_JS_CDN = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.js';
    var LEAFLET_CSS_CDN = 'https://cdn.jsdelivr.net/npm/leaflet@1.9.4/dist/leaflet.css';

    var partyColors = {
        reform: '#26C6DA',
        lab: '#FF1744',
        con: '#1E88E5',
        lib: '#F6A800',
        snp: '#F2D232',
        green: '#5AD313',
        plaid: '#00C853',
        other: '#BDBDBD'
    };

    var root = document.querySelector('[data-seat-detail-map-widget]');
    if (!root) return;

    var canvas = root.querySelector('[data-seat-detail-map-canvas]');
    var statusEl = root.querySelector('[data-seat-detail-map-status]');
    var shareBtn = root.querySelector('[data-seat-detail-share-btn]');
    if (!canvas) return;

    var state = {
        map: null,
        layer: null,
        seatId: null,
        winner: null
    };

    function setStatus(msg) {
        if (statusEl) statusEl.textContent = msg || '';
    }

    function getSeatUrl() {
        var match = window.location.pathname.match(/^\/seats\/([A-Za-z0-9_%-]+)\/?$/i);
        if (!match) return window.location.origin + '/seats/';
        var code = decodeURIComponent(match[1]).trim().toUpperCase();
        return window.location.origin + '/seats/' + encodeURIComponent(code);
    }

    function getShareImageUrl() {
        var el = document.querySelector('meta[property="og:image"]') || document.querySelector('meta[name="twitter:image"]');
        return (el && el.getAttribute('content')) || '';
    }

    function wireShareButton(seat) {
        if (!shareBtn) return;
        var seatName = seat && seat.constituency_name ? String(seat.constituency_name).trim() : '';
        var shareText = seatName ? seatName + ' | UK Polling Report' : 'Seat forecast | UK Polling Report';
        var shareImage = getShareImageUrl();

        shareBtn.setAttribute('data-share-capture', 'seat-detail');
        shareBtn.setAttribute('data-share-url', getSeatUrl());
        shareBtn.setAttribute('data-share-text', shareText);
        if (shareImage) {
            shareBtn.setAttribute('data-share-image', shareImage);
        }
    }

    function ensureLeaflet(done) {
        function ensureCss(cb) {
            var existing = document.querySelector('link[data-ukpr-leaflet-css]');
            if (existing) return cb();
            var link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = LEAFLET_CSS_CDN;
            link.setAttribute('data-ukpr-leaflet-css', 'true');
            link.onload = cb;
            link.onerror = cb;
            document.head.appendChild(link);
        }

        function ensureJs(cb) {
            if (window.L && window.L.map) return cb();
            var current = document.querySelector('script[data-ukpr-leaflet-js]');
            if (current) {
                current.addEventListener('load', cb, { once: true });
                return;
            }
            var script = document.createElement('script');
            script.src = LEAFLET_JS_CDN;
            script.setAttribute('data-ukpr-leaflet-js', 'true');
            script.onload = cb;
            script.onerror = cb;
            document.head.appendChild(script);
        }

        ensureCss(function () { ensureJs(done); });
    }

    function getWinnerColor() {
        var key = String(state.winner || '').toLowerCase();
        return partyColors[key] || '#9E9E9E';
    }

    function initMap() {
        if (state.map) return;
        state.map = window.L.map(canvas, {
            attributionControl: false,
            zoomControl: false,
            boxZoom: false,
            doubleClickZoom: false,
            dragging: false,
            scrollWheelZoom: false,
            minZoom: 3,
            maxZoom: 18
        }).setView([51.4995, -0.1248], 11);

        window.L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
            maxZoom: 19,
            attribution: '&copy; OpenStreetMap'
        }).addTo(state.map);
    }

    function renderGeojson(geojson) {
        if (!state.map || !geojson) return;

        if (state.layer) {
            state.map.removeLayer(state.layer);
            state.layer = null;
        }

        state.layer = window.L.geoJSON(geojson, {
            style: function () {
                return {
                    color: getWinnerColor(),
                    fillColor: getWinnerColor(),
                    weight: 1.2,
                    opacity: 0.95,
                    fillOpacity: 0.22
                };
            }
        }).addTo(state.map);

        var bounds = state.layer.getBounds();
        if (bounds && bounds.isValid()) {
            state.map.fitBounds(bounds, {
                padding: [16, 16],
                maxZoom: 12
            });
        }

        setStatus('');
    }

    function loadSeatGeojson() {
        if (!state.seatId) return;
        setStatus('');
        fetch(API_BASE + '/seats/' + encodeURIComponent(state.seatId) + '/geojson')
            .then(function (r) { return r.json(); })
            .then(renderGeojson)
            .catch(function () { setStatus('Map unavailable'); });
    }

    document.addEventListener('ukpr:seat-detail-loaded', function (ev) {
        var seat = ev && ev.detail ? ev.detail.seat : null;
        if (!seat || !seat.id) return;

        state.seatId = seat.id;
        state.winner = seat.winner;

        ensureLeaflet(function () {
            if (!window.L || !window.L.map) {
                setStatus('Map unavailable');
                return;
            }
            initMap();
            loadSeatGeojson();
        });

        wireShareButton(seat);
    });
})();
